// let httpContent = '//pc-api.996box.com'
// 生产环境
// if (process.env.NODE_ENV === "production") {
//   httpContent = "//pc-api.996box.com";
// }

// // 测试环境
// if (process.env.NODE_ENV === "test") {
//   httpContent = "http://pc-api-dev.996box.com";
// }

// // 开发环境
// if (process.env.NODE_ENV === "development") {
//   httpContent = "http://pc-api.996box.com";
// }

let baiduBdVidApi = `//user-api.996box.com/v1/ChannelBuyUserCheck/baiduCheck`;
const httpJava = process.env.VUE_APP_JAVA_URL; // java接口
const httpUser = process.env.VUE_APP_USER_BASE_URL; // 用户

const firstVersoin = `/v1`; // 第一版

// 开发环境
if (process.env.NODE_ENV === "development") {
  baiduBdVidApi = `http://boxuser-dev.dhsf.xqhuyu.com/v1/ChannelBuyUserCheck/baiduCheck`;
}

export default {
  newWeb: {
    withRankJava: `//pc-api.996box.com/v1/homeapi/FindGame/getGameListWithRank`,
    uploadConvertDatabdVid: baiduBdVidApi,
  },
  homes: {
    // 获取ios下载key
    getIosAppKey: `${httpUser}${firstVersoin}/ChannelDownLink/getBoxIosDownurl`,
    // 获取盒子下载链接
    getDownUrl: `${httpUser}${firstVersoin}/ChannelDownLink/getDownUrl`,
    allRankGames: `${httpJava}/box/v1/rankGames`,
  },
};
